export interface HowWeHelpPage {
	title: string;
	text: string;
	link: string;
	imageUrl: string;
}

export const howWeHelpPages: HowWeHelpPage[] = [
	{
		title: "AI with Guardrails",
		text: "Safe AI that integrates with your LMS and supports academic integrity.",
		link: "/how-we-help/ai-with-guardrails",
		imageUrl: "/responsible-and-safe-ai.png"
	},
	{
		title: "Adaptive Learning",
		text: "Personalised paths that adapt to your pace and learning style.",
		link: "/how-we-help/adaptive-learning",
		imageUrl: "/how-we-help/adaptive-learning/adaptive-learning.png"
	},
	{
		title: "Learner Insights",
		text: "Data-driven insights to understand and improve student learning outcomes.",
		link: "/how-we-help/learner-insights",
		imageUrl: "/how-we-help/learner-insights/learner_insights_thumbnail.png"
	},
	{
		title: "Neuroscience",
		text: "Evidence-based methods grounded in cognitive neuroscience.",
		link: "/how-we-help/neuroscience",
		imageUrl: "/how-we-help/neuroscience/the-neuroscience-thumb.png"
	},
	{
		title: "Reduced Workload",
		text: "AI tools that cut admin tasks so you can focus on learning.",
		link: "/how-we-help/reduced-workload",
		imageUrl: "/how-we-help/reduced-workload/reduced-workload.png"
	}
];

// Function to get 3 related pages excluding the current one
// Uses deterministic selection to avoid hydration errors
export function get__related_how_we_help_pages(currentPath: string): HowWeHelpPage[] {
	const filteredPages = howWeHelpPages.filter(page => page.link !== currentPath);
	
	// Use a simple rotation based on the current path to ensure consistency
	const currentIndex = howWeHelpPages.findIndex(page => page.link === currentPath);
	const startIndex = currentIndex % filteredPages.length;
	
	// Take 3 pages starting from the calculated index, wrapping around if needed
	const result: HowWeHelpPage[] = [];
	for (let i = 0; i < 3 && i < filteredPages.length; i++) {
		const index = (startIndex + i) % filteredPages.length;
		result.push(filteredPages[index]);
	}
	
	return result;
}
